import { _ as d, l as r, L as i, o as m } from "./main-Df9wF57H.js";
import { openBlock as o, createElementBlock as s, Fragment as p, renderList as _, normalizeClass as u, createElementVNode as l, toDisplayString as a } from "vue";
const h = {
  name: "ThemeControl",
  props: {
    modelValue: {
      type: String,
      required: !0,
      default: r
    }
  },
  data() {
    return {
      themeOptions: [r, i, m]
    };
  },
  computed: {
    themeSelected() {
      return this.modelValue;
    }
  },
  methods: {
    onSelectTheme(t) {
      this.$emit("update:modelValue", t);
    }
  }
}, T = { class: "inline-control space-between gap-10" }, E = ["onClick"], f = { class: "theme-example" }, v = { class: "name" };
function S(t, $, b, k, c, n) {
  return o(), s("div", T, [
    (o(!0), s(p, null, _(c.themeOptions, (e) => (o(), s("div", {
      key: e,
      class: u([[e, { selected: n.themeSelected === e }], "theme"]),
      onClick: (C) => n.onSelectTheme(e)
    }, [
      l("div", f, a(t.$t("builder.controls.theme.aUppercase")), 1),
      l("div", v, a(t.$t(`builder.controls.theme.${e}`)), 1)
    ], 10, E))), 128))
  ]);
}
const L = /* @__PURE__ */ d(h, [["render", S], ["__scopeId", "data-v-4d9bdb16"]]);
export {
  L as T
};
